import React from 'react';
import { Lock, Inbox, CloudOff, SearchX, ShieldAlert, AlertTriangle } from 'lucide-react';

// Semantically distinct empty/unavailable states — never a generic "No data".
// variant: 'feature-disabled' | 'no-records' | 'source-unavailable' | 'no-filter-results' | 'access-restricted' | 'loading-failure'
const VARIANTS = {
  'feature-disabled': { Icon: Lock, tone: 'text-amber-500', title: 'Feature not enabled', message: 'This capability is currently disabled. Configuration is preserved; no operational actions are available.' },
  'no-records': { Icon: Inbox, tone: 'text-gray-300', title: 'No records yet', message: 'Records will appear here once they are created.' },
  'source-unavailable': { Icon: CloudOff, tone: 'text-slate-400', title: 'Source unavailable', message: 'The data source is temporarily unavailable. Try refreshing shortly.' },
  'no-filter-results': { Icon: SearchX, tone: 'text-gray-300', title: 'No matching records', message: 'No records match the current filters.' },
  'access-restricted': { Icon: ShieldAlert, tone: 'text-slate-400', title: 'View-only access', message: 'You have view-only access to this section.' },
  'loading-failure': { Icon: AlertTriangle, tone: 'text-red-400', title: 'Could not load data', message: 'Something went wrong loading this data. Please try again.' },
};

export const EmptyState = ({ variant = 'no-records', title, message, action, testid, compact = false }) => {
  const v = VARIANTS[variant] || VARIANTS['no-records'];
  const Icon = v.Icon;
  return (
    <div className={`text-center ${compact ? 'py-8' : 'py-12'} px-4`} data-testid={testid || `empty-state-${variant}`}>
      <Icon className={`w-10 h-10 mx-auto mb-3 ${v.tone}`} />
      <p className="font-medium text-gray-700">{title || v.title}</p>
      <p className="text-sm text-gray-500 mt-1 max-w-md mx-auto">{message || v.message}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};

export default EmptyState;
